// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2mHSQ","title":"ClientReferral_title__2k11X","itemText":"ClientReferral_itemText__26EaI"};